import {Component, Inject, OnDestroy, OnInit, HostListener} from '@angular/core';
import {DOCUMENT} from '@angular/platform-browser';
import {LoginService} from './services/login.service';
import {ModalHelper} from './services/modalService/modal.helper';
import {User} from './services/model/user';
import {EventService} from './services/event.service';
import {Subscription} from 'rxjs/Subscription';
import {NavigationEnd, Router, NavigationStart, NavigationCancel} from '@angular/router';
import {GoogleAnalyticsService} from './services/google-analytics-service';
import {LocalStorageService} from 'angular-2-local-storage';
import {NotificationsService} from "angular2-notifications";
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'app';
  isLoggedIn = false;
  state: string;
  code: string;
  url: any;
  currentUser: User;
  userAdmin = false;
  

  currentLang: string;

  notificationOptions = {
    timeOut: 4000,
    preventDuplicates: false,
    showProgressBar: false,
    clickToClose: true,
    position: ['bottom', 'right'],
    animate: 'fromRight'
  };

  private subscription: Subscription;

  constructor(private modalHelper: ModalHelper,
              private localStorageService: LocalStorageService,
              private loginService: LoginService,
              private eventService: EventService,
              private notificationsService: NotificationsService,
              private ga: GoogleAnalyticsService,
              private router: Router,
              public translate: TranslateService,
              @Inject(DOCUMENT) private document: any) {
    // translate.setDefaultLang(localStorage.getItem('lang') || 'en');
    this.currentLang = localStorage.getItem('lang') || 'en';
    this.url = this.document.location;
    this.localStorageService.remove('isParsed');
    this.currentUser = this.loginService.getCurrentUser();
    this.subscription = this.eventService.getMessage().subscribe((event) => {
        if (event.type === 'user') {
            const newUser = event.data;
            let logoutDetected = false;
            if (this.currentUser.isLoggedIn && !newUser.isLoggedIn) {
                // console.log('logout detected');
                logoutDetected = true;
            }
            this.currentUser = newUser;
            this.isLoggedIn = this.currentUser.isLoggedIn;
            this.userAdmin = this.currentUser.admin;
            if (logoutDetected) {
                this.router.navigate(['/home']);
            }
        }
    });

    this.setUpRouterAnalytics();
  }

    private setUpRouterAnalytics() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.ga.emitPageView(event.urlAfterRedirects);
            }
            window.scrollTo(0, 0)
        });
    }

    @HostListener('window:storage', [])
    onStorageChange() {
        const stroageLang = window.localStorage.getItem('lang');
        if (stroageLang !== this.currentLang) {
            this.switchLanguage(stroageLang);
        }
    }

  ngOnInit() {
    const firstUrls = [];
    // const lang: String = window.localStorage.getItem('lang');
    // if(lang !== 'en' && lang !== 'ja') {
    //     const browserLang = window.navigator.language.split("-")[0];
    //     browserLang !== 'en' && browserLang !== 'ja' ? this.switchLanguage('en') : this.switchLanguage(browserLang);
    // }

    if (this.getParameterByName('state', this.url) != null) {
      this.state = this.getParameterByName('state', this.url);
      this.code = this.getParameterByName('code', this.url);
    }

	let login = {
		userInfoIp : '',
		userInfoCity : '',
		userInfoRegion : '',
		userInfoCountry : ''
	};
	this.loginService.getUserInfo().subscribe((res) => {
		login.userInfoIp = res.json().ip ? res.json().ip : '';
		login.userInfoCity = res.json().city ? res.json().city : '';
		login.userInfoRegion = res.json().region ? res.json().region : '';
		login.userInfoCountry = res.json().country ? res.json().country : '';
		this.loginService
        .checkLoggedIn(login, this.state, this.code)
        .subscribe((user) => {
            console.log('Logged in');
            // this.currentUser = user;
            // this.isLoggedIn = user.isLoggedIn;
            // this.userAdmin = user.admin;
            // if (this.state && this.code) {
            //     const newLocation = location.href.replace(location.search, '');
            //     location.href = newLocation;
            // }
        }, () => {
            // console.log('Not logged in');
        });
    }, (error) => {
    	// console.log(error);
    	this.loginService
        .checkLoggedIn(login, this.state, this.code)
        .subscribe((user) => {
            console.log('Logged in Error');
            // this.currentUser = user;
            // this.isLoggedIn = user.isLoggedIn;
            // this.userAdmin = user.admin;
            // if (this.state && this.code) {
            //     const newLocation = location.href.replace(location.search, '');
            //     location.href = newLocation;
            // }
        }, () => {
            // console.log('Not logged in');
        });
    });
  }

  switchLanguage(language: string): void {
    if(language==='ja') {
    	this.sendGaEvent('Japanese Language');
    } else {
    	this.sendGaEvent('English Language');
    }
    
    this.translate.use(language);
    window.localStorage.setItem('lang', language);
    this.currentLang = language;
    if (this.currentUser.isLoggedIn) {
        this.loginService.serverLocalization();
    }
    window.location.reload();
  }

  loginPrompt() {
  	  this.sendGaEvent('Sign in');
  	  this.localStorageService.set('isAccessLogInMenu', false);
      this.modalHelper.openLogin({});
  }

  createAccount() {
  	  this.sendGaEvent('Create free account');
  	  this.localStorageService.set('isAccessLogInMenu', false);
      this.modalHelper.openCreate({}, null);
  }

  private isAccessExpired():boolean {
        return this.currentUser.paidTo && !this.currentUser.paid;
  }

  signOut() {
  	this.sendGaEvent('Log out');
    this.loginService.signOut();
  }

  getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  ngOnDestroy(): void {
        this.subscription.unsubscribe();
  }
  
  sendGaEvent(ea) {
  		this.ga.emitEvent('Main Menu', ea, 'Click');
  }
  
  sendGaEventFooter(ea) {
  		this.ga.emitEvent('Footer', ea, 'Click');
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/app.component.ts